import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";

@CwtModel({ name: 'fund-type' })
@CwtCrudContract({ path: '/fund-type' })
export class FundType extends CwtApiEntity {
    @CwtProp() name: string;
}